import CompanyGrowthChartComponent from "../../components/company/company_growth_chart"
import { PageLayout } from "../../components/common/page-layout"

export const CompanyGrowthPage = () => {
    return (
        <PageLayout>
            <CompanyGrowthChartComponent />
        </PageLayout>
    );
};